<div class="report-hub-container" *ngIf="!isLoadingLabels && !isLoadingReportList && !isLoadingCockpit && !isLoadingReportData">
	<div class="header">
		<span class="title">{{ labels.lbl_geral_reports }}</span>
		<div class="button-container">
			<div class="button" (click)="openModalEvaluationMSP()">{{ labels.lbl_geral_avaliar }} MySupport</div>
			<div class="button" (click)="pageView = 'report-select'" *ngIf="pageView === 'report-list'">{{ labels.lbl_create_report }}</div>
			<div class="button" (click)="downloadInViewReport()" *ngIf="pageView === 'report-read'">{{ labels.lbl_baixar_relatorio }}</div>
			<div class="button" (click)="resetReportHub()" *ngIf="pageView !== 'report-list'">{{ labels.lbl_geral_voltar }}</div>
		</div>
	</div>
	<div class="body" [ngClass]="{ 'no-padding': pageView === 'report-read' }">
		<ng-container *ngIf="pageView === 'report-list'">
			<span class="title">{{ labels.lbl_relatorios_salvos }}</span>
			<div class="report-list-container">
				<div class="report" *ngFor="let report of reportList">
					<div class="name">
						<span class="link">{{ labels[report.type_label] ? labels[report.type_label] : report.type_label }}</span>
						<span [title]="report.id">{{ report.name }}</span>
					</div>
					<span
						class="reportOptionsClosed"
						(click)="reportOptionsClosed.classList.add('hide'); reportOptionsOpen.classList.remove('hide')"
						#reportOptionsClosed
						><fa-icon [icon]="icons.faGear"></fa-icon
					></span>
					<div class="reportOptionsOpen hide" #reportOptionsOpen>
						<span
							class="option link"
							(click)="reportOptionsClosed.classList.remove('hide'); reportOptionsOpen.classList.add('hide')"
							><fa-icon [icon]="icons.faGear"></fa-icon
						></span>
						<span
							class="option"
							[title]="labels.lbl_geral_excluir_relatorio"
							(click)="
								deleteReportListRef.classList.contains('confirm')
									? deleteReport(report.id)
									: confirmButton(deleteReportListRef)
							"
							#deleteReportListRef
							><fa-icon [icon]="icons.faTrash"></fa-icon
						></span>
						<span
							class="option"
							[title]="labels.lbl_baixar_relatorio"
							(click)="downloadReport(report.id, report.type, report.sub_type, report.name)"
							><fa-icon [icon]="icons.faDownload"></fa-icon
						></span>
						<span
							class="option"
							[title]="labels.lbl_geral_editar_relatorio"
							(click)="
								idSelectedReport = report.id;
								reportType.name = report.type;
								reportType.label = report.type_label;
								reportSubType.name = report.sub_type;
								setSubType();
								pageView = 'edit'
							"
							><fa-icon [icon]="icons.faPenToSquare"></fa-icon
						></span>
						<span
							class="option"
							[title]="labels.lbl_visualizar_relatorio"
							(click)="getReportData(report.id, report.type, report.sub_type, report.name)"
							><fa-icon [icon]="icons.faArrowUpRightFromSquare"></fa-icon
						></span>
					</div>
				</div>

				<div class="empty-report" *ngIf="reportList.length === 0">
					{{ labels.lbl_rep_custom_nao_ha_relatorios }}
				</div>
			</div>
		</ng-container>

		<ng-container *ngIf="pageView === 'report-select'">
			<span class="title">{{ labels.lbl_selecione_tipo_relatorio }}</span>
			<span
				class="long-button"
				(click)="
					reportType.name = 'request'; reportType.label = 'lbl_geral_chamado'; pageView = 'report-select-sub'; setSubTypeOptions()
				"
				*ngIf="PermissionService.hasPermission('access_request')"
				>{{ labels.lbl_geral_chamado }}</span
			>
			<span
				class="long-button"
				(click)="
					reportType.name = 'stock'; reportType.label = 'lbl_status_estoque'; pageView = 'report-select-sub'; setSubTypeOptions()
				"
				*ngIf="PermissionService.hasPermission('access_stock')"
				>{{ labels.lbl_status_estoque }}</span
			>
			<span
				class="long-button"
				(click)="reportType.name = 'cmdb'; reportType.label = 'lbl_cmdb'; pageView = 'report-select-sub'; setSubTypeOptions()"
				*ngIf="PermissionService.hasPermission('access_cmdb')"
				>{{ labels.lbl_cmdb }}</span
			>
			<span
				class="long-button"
				(click)="
					reportType.name = 'evaluate';
					reportType.label = 'lbl_chamado_avaliacoes';
					pageView = 'report-select-sub';
					setSubTypeOptions()
				"
				>{{ labels.lbl_chamado_avaliacoes }}</span
			>
		</ng-container>

		<ng-container *ngIf="pageView === 'report-select-sub'">
			<span class="title">{{ labels.lbl_selecione_tipo_relatorio }}</span>
			<span class="long-button" (click)="handleReportSubtypeSelection(subtype)" *ngFor="let subtype of reportSubTypeOptions">
				{{
					labels[subtype.label]
						? labels[subtype.label]
						: subtype.name === 'equipmentHistoryByUser'
							? 'Histórico de Equipamentos por Usuário'
							: subtype.name
				}}
			</span>
		</ng-container>

		<ng-container *ngIf="pageView === 'register' || pageView === 'edit'">
			<app-report-form
				[labels]="labels"
				[formStage]="pageView"
				[reportType]="reportType"
				[reportSubType]="reportSubType"
				[idReport]="idSelectedReport"
				(goToHub)="resetReportHub()">
			</app-report-form>
		</ng-container>

		<ng-container *ngIf="pageView === 'report-read'">
			<cpi-msp-table [header]="reportHeader" [body]="reportDataRework" [labels]="labels" [height]="'80%'" [tableOnly]="true">
			</cpi-msp-table>
			<!-- <pcp-custom-columns-excel
            (spreadsheetInView)="reportDataInView = $event"
            [spreadsheet]="reportData">
            </pcp-custom-columns-excel> -->
		</ng-container>
	</div>
</div>

<div
	class="evaluation-msp-modal evaluation-msp-modal-extremity-close"
	id="modalClose"
	(click)="modalClose($event, false)"
	*ngIf="isOpenModalEvaluationMSP">
	<div class="evaluation-msp-modal-content">
		<span class="evaluation-msp-modal-close" (click)="modalClose($event, true)"><fa-icon [icon]="icons.faXmark"></fa-icon></span>
		<app-mysupport-evaluation></app-mysupport-evaluation>
	</div>
</div>

<div class="loading-container" *ngIf="isLoadingLabels || isLoadingReportList || isLoadingCockpit || isLoadingReportData">
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ labels.lbl_edocs_carregando }}!</div>
</div>
